import { useQuery } from '@apollo/client'
import { GET_PREQUALIFIED_SITES } from './queries'

export function useGetPreQualifiedSites() {
  return useQuery(GET_PREQUALIFIED_SITES)
}
